import React from 'react';
import { Container, Grid, Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { NavigationBackButton, ProviderDialogNavigation, UpliftThemeProvider, FullScreenLayout } from '@uplift/ui-v2';
import { DateFormats, patientIntakeFormRoute } from '@uplift/constants';
import { useFormSubmissionResultsQuery } from '@uplift/queries';
import { useL10n } from '@uplift/hooks';
import { useHistory } from 'react-router';
import { CalendarDateService } from '@uplift/services';
import { useTimezone } from '@uplift/contexts';
import { FormResponsesReviewTable } from '../../components';


const useStyles = makeStyles()(theme => ({
  container: {
    maxWidth: '588px',
    marginTop: theme.spacing(9),
    marginBottom: theme.spacing(9),
  },
  subtitle: {
    marginBottom: theme.spacing(6),
  },
  dateTime: {
    fontWeight: 600,
  }
}));


export const PatientIntakeFormPage: React.VFC = () => {
  const l10n = useL10n();
  const timezone = useTimezone();
  const params = patientIntakeFormRoute.useParams();
  const history = useHistory();
  const { classes } = useStyles();

  const { data } = useFormSubmissionResultsQuery(params.submissionId);
  const completedAt = React.useMemo(() => {
    if (!data) return null;

    if (data?.responses?.complete === true) {
      return CalendarDateService.date(data.responses.updatedAt).tz(timezone);
    } else if (data?.responses?.complete === false) {
      return undefined;
    }
    return null;
  }, [ data, timezone ]);

  return (
    <UpliftThemeProvider>
      <FullScreenLayout
        navigation={(
          <ProviderDialogNavigation
            position="fixed"
            leftActions={(
              <NavigationBackButton onClick={history.goBack}>
                {l10n.patientIntakeForm.backToChart}
              </NavigationBackButton>
            )}
          />
        )}
      >
        <Container className={classes.container}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <Typography variant="h1" data-title={data?.title}>{data?.title}</Typography>
              <Typography variant="body1" className={classes.subtitle}>
                {l10n.patientIntakeForm.submittedOn} <span className={classes.dateTime}>{completedAt?.format(DateFormats['M/D/YYYY'])}</span> {l10n.patientIntakeForm.atTime} <span className={classes.dateTime}>{completedAt?.format('h:mm a')}</span>
              </Typography>
              <FormResponsesReviewTable submissionId={params.submissionId} />
            </Grid>
          </Grid>
        </Container>
      </FullScreenLayout>
    </UpliftThemeProvider>
  );
};
